import { makeStyles, StepConnector, withStyles } from "@material-ui/core";
import { StepIconProps } from "@material-ui/core/StepIcon";
import React from "react";

export const DropOffStepperConnector = withStyles(
  {
    active: {
      "& $line": {
        borderColor: "#D9D9D9"
      }
    },
    alternativeLabel: {
      left: "calc(-50% + 12px)",
      right: "calc(50% + 12px)",
      top: 10
    },
    completed: {
      "& $line": {
        borderColor: "#D9D9D9"
      }
    },
    line: {
      borderColor: "#eaeaf0",
      borderRadius: 1,
      borderTopWidth: 4
    }
  },
  { name: "DropOffStepperConnector" }
)(StepConnector);

const useDropOffStepIconStyles = makeStyles(
  {
    active: {
      color: "#FFDB00 !important"
    },
    circle: {
      backgroundColor: "currentColor",
      borderRadius: "50%",
      height: 24,
      width: 24
    },
    completed: {
      color: "#FFDB00 !important",
      fontSize: 18,
      zIndex: 1
    },
    root: {
      alignItems: "center",
      color: "#ADB4BB",
      display: "flex",
      height: 22
    }
  },
  { name: "DropOffStepperIconStyles" }
);

export const DropOffStepIcon = (props: StepIconProps) => {
  const classes = useDropOffStepIconStyles(props);
  const { active, completed } = props;

  return (
    <div
      className={`${classes.root} ${active || completed ? classes.active : ""}`}
    >
      <div className={classes.circle} />
    </div>
  );
};
